import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_UPDATE_COLLECTIONS_BEGIN,
  COLLECTIONS_UPDATE_COLLECTIONS_SUCCESS,
  COLLECTIONS_UPDATE_COLLECTIONS_FAILURE,
  COLLECTIONS_UPDATE_COLLECTIONS_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function updateCollections(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_UPDATE_COLLECTIONS_BEGIN,
    });
    const { projectId, collectionId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${collectionId}`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_UPDATE_COLLECTIONS_SUCCESS,
              data: res.data,
            });
            Mixpanel.track('Updated Collection', { uuid: args.collectionId });
            toast.success('Updated Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_UPDATE_COLLECTIONS_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Update Collection Failed');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Updation Failed: ${errMsg} `);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_UPDATE_COLLECTIONS_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Update Collection Failed');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Updation Failed: ${errMsg} `);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateCollectionsError() {
  return {
    type: COLLECTIONS_UPDATE_COLLECTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_UPDATE_COLLECTIONS_BEGIN:
      return {
        ...state,
        updateCollectionsPending: true,
        updateCollectionsError: null,
      };

    case COLLECTIONS_UPDATE_COLLECTIONS_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex(function (item, i) {
        return item._id === action.data._id;
      });
      projectCollections[index] = action.data;
      return {
        ...state,
        updateCollectionsPending: false,
        updateCollectionsError: null,
        projectCollections,
        selectedCollection: action.data,
      };

    case COLLECTIONS_UPDATE_COLLECTIONS_FAILURE:
      return {
        ...state,
        updateCollectionsPending: false,
        updateCollectionsError: action.data.error,
      };

    case COLLECTIONS_UPDATE_COLLECTIONS_DISMISS_ERROR:
      return {
        ...state,
        updateCollectionsError: null,
      };

    default:
      return state;
  }
}
